/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const VisSingleValue: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M8.53973 12.7857C8.53973 10.6664 8.95173 9.0817 9.77506 8.0317C10.5984 6.9817 11.8171 6.45703 13.4297 6.45703C13.9851 6.45703 14.4231 6.5037 14.7424 6.59703V7.6517C14.3637 7.52903 13.9311 7.46703 13.4444 7.46703C12.2884 7.46703 11.4057 7.8277 10.7964 8.5477C10.1871 9.2677 9.8524 10.4004 9.79306 11.9444H9.88173C10.4224 11.0984 11.2784 10.6757 12.4484 10.6757C13.4171 10.6757 14.1804 10.9684 14.7384 11.5537C15.2964 12.139 15.5757 12.933 15.5757 13.9364C15.5757 15.0577 15.2697 15.939 14.6577 16.581C14.0457 17.223 13.2184 17.5437 12.1757 17.5437C11.0591 17.5437 10.1744 17.1244 9.5204 16.2857C8.8664 15.447 8.53906 14.2804 8.53906 12.7857H8.53973ZM12.1617 16.5037C12.8597 16.5037 13.4024 16.2837 13.7884 15.8437C14.1744 15.4037 14.3671 14.7684 14.3671 13.937C14.3671 13.2244 14.1877 12.6637 13.8284 12.255C13.4691 11.8464 12.9337 11.643 12.2204 11.643C11.7777 11.643 11.3724 11.7344 11.0031 11.9164C10.6337 12.0984 10.3404 12.349 10.1217 12.669C9.90306 12.9884 9.79373 13.3204 9.79373 13.665C9.79373 14.1717 9.8924 14.6437 10.0884 15.081C10.2844 15.5184 10.5644 15.8657 10.9257 16.121C11.2871 16.377 11.6991 16.5044 12.1611 16.5044L12.1617 16.5037Z" />

      <path d="M19.9732 19.9147H4.14319V4.08466H19.9732V19.9147ZM4.65386 19.404H19.4625V4.59532H4.65386V19.404Z" />

    </StyledIconBase>
  )
})

VisSingleValue.displayName = 'VisSingleValue'

export const VisSingleValueDimensions = {height: 24, width: 24}
